export default "__VITE_ASSET__DLk4fvYK__"